import { lazy } from 'react';

// ----------------------------------------------------------------------

const EmployeeDetailsPage = lazy(() => import('../pages/EmployeeDetails.page'));
const EmployeesPage = lazy(() => import('../pages/Employees.page'));
const AddEmployeePage = lazy(() => import('../pages/AddEmployee.page'));
const EditEmployeePage = lazy(() => import('../pages/EditEmployee.page'));
const AddLecturerPage = lazy(() => import('../pages/lecture/AddLecturer.page'));
const InstructorDetails = lazy(() => import('../pages/lecture/InstructorDetails.page'));

// ----------------------------------------------------------------------

const HumanResourcesRoutes = [
    {
        path: '/human-resources',
        children: [
            { path: 'employees', element: <EmployeesPage />, layout: 'default', isAuthReq: true },
            { path: 'add-employee', element: <AddEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id', element: <EmployeeDetailsPage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id/edit', element: <EditEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'add-lecturer', element: <AddLecturerPage />, layout: 'default', isAuthReq: true },
            { path: 'lecturer/:id/edit', element: <AddLecturerPage />, layout: 'default', isAuthReq: true },
            { path: 'lecturer/:id', element: <InstructorDetails />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { HumanResourcesRoutes };
